import PageWrapper from "components/page/PageWrapper";
import {useTranslation} from 'react-i18next'
import { useState, useCallback } from 'react';

import TabBar from 'components/tabbar/TabBar';
import Company from 'components/company/Company';

import ProductHd from "./ProductHd";
import ProductQc from "./ProductQc";
import ProductSr from "./ProductSr";

import bg from 'assets/images/banner/banner02.jpg';

export default function Inverters(){
  const {t} =  useTranslation();
  const menuName= t('menu.sub-inverters');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/inverters', name:menuName}];
  const title = t('inverters.banner.title');
  const comment = t('inverters.banner.comment');

  const tabs = [
    t('inverters.tabs.name-1'),
    t('inverters.tabs.name-2'),
    t('inverters.tabs.name-3')
  ];
  const prefix = ['hd', 'sr', 'qc'];
  const width = [243, 215, 135];
  const [index, setIndex] = useState(0);
  const handleClick = useCallback((index)=>{
    setIndex(index);
  }, [setIndex]);

  const products = [
    <ProductHd/>,
    <ProductSr/>,
    <ProductQc/>
  ];

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      
      <div className='flex flex-col w-full px-0 lg:items-center'>
        <TabBar tabs={tabs} callback={handleClick} selected={index} className='px-mobile lg:px-0'/>
        <Company module={'inverters'} prefix={prefix[index]} index={index} ciWidth={width[index]} className={`px-mobile lg:px-0`}/>
        {products[index]}
      </div>
    </PageWrapper>
  );
}